$(function(){
  $(window).on('load',function(){
    if($.cookie('intro') != 'on') {
      $('html,body').animate({ scrollTop: 0 }, '1');
      var flg = false;
      setTimeout(function(){
        var win = $(window).innerWidth();
        var img = "";
        if(win > 767) {
          img = "https://cdn.shopify.com/s/files/1/0448/2334/7352/files/street_intro.gif?v=1622427176";
        } else {
          img = "https://cdn.shopify.com/s/files/1/0448/2334/7352/files/street_intro_sp.gif?v=1622427176";
        }
        $.when(
          $('.street_intro img').attr('src',img)
        ).done(function() {
          setTimeout(function(){
            $(".street_intro").fadeOut(2000);
            setTimeout(function(){
              $(".street").addClass('active');
              flg = true;
            },300);
          },8000);
        });
      },1000);
      date = new Date();
      $.cookie('intro', 'on', { expires: 1 });
    } else {
      flg = true;
      $(".street_intro").hide();
      $(".street").addClass('active');
    }
    
    var figure_anime = true;
    $(window).on('scroll',function(){
      if (flg) {
        var scroll = $(window).scrollTop();
        var windowHeight = $(window).height();
        $(".street_mv_img").each(function(){
          var imgPos = $(this).offset().top;
          if (scroll > imgPos - windowHeight + windowHeight/1.2){
            $(this).next().addClass("anime");
          }
        });
        $(".street_soon_text").each(function(){
          var soon = $(this).offset().top;
          if (scroll > soon - windowHeight + windowHeight/3){
            $(this).addClass("anime");
          }
        });
        if (figure_anime) {
          var figure = $(".figure").offset().top;
          if (scroll > figure - windowHeight + windowHeight/5){
            $("#street_figure").attr('src','https://cdn.shopify.com/s/files/1/0448/2334/7352/files/street_figure.gif?v=1622782149');
            figure_anime = false;
          }
        }
      }
    });
    
  });
});
